var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHide20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53 4.47a.75.75 0 0 0-1.06 1.06l1.074 1.075C3.94 7.836 3 9.42 3 10c0 1 2.8 5 7 5a6.92 6.92 0 0 0 3.158-.782l1.312 1.312a.75.75 0 1 0 1.06-1.06l-10-10Zm6.357 8.478-1.498-1.499A1.503 1.503 0 0 1 8.5 10c0-.134.018-.265.05-.389L7.053 8.113a3.5 3.5 0 0 0 4.835 4.835Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10c0 .14-.008.279-.024.415l2.033 2.034C16.464 11.449 17 10.438 17 10c0-1-2.8-5-7-5-.601 0-1.174.082-1.714.225l1.299 1.3A3.5 3.5 0 0 1 13.5 10Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide20);
export default __webpack_public_path__ + "static/media/hide_20.48ffd45f.svg";
export { ForwardRef as ReactComponent };